import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  STUDENT_PRIVACY_STORAGE_KEY,
  readStudentPrivacyPreference,
} from "../utils/studentPrivacy";

const StudentPrivacyContext = createContext({
  blurStudentNames: false,
  toggleBlurStudentNames: () => {},
  setBlurStudentNames: () => {},
});

export const StudentPrivacyProvider = ({ children }) => {
  const [blurStudentNames, setBlurStudentNames] = useState(() =>
    readStudentPrivacyPreference()
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      window.localStorage.setItem(
        STUDENT_PRIVACY_STORAGE_KEY,
        blurStudentNames ? "1" : "0"
      );
    } catch (error) {
      // Ignore storage write failures (private browsing, disabled storage, etc.)
    }
    document.body.classList.toggle("student-name-blur-active", blurStudentNames);
    return () => {
      document.body.classList.remove("student-name-blur-active");
    };
  }, [blurStudentNames]);

  const toggleBlurStudentNames = useCallback(() => {
    setBlurStudentNames((previousValue) => !previousValue);
  }, []);

  const value = useMemo(
    () => ({
      blurStudentNames,
      setBlurStudentNames,
      toggleBlurStudentNames,
    }),
    [blurStudentNames, toggleBlurStudentNames]
  );

  return (
    <StudentPrivacyContext.Provider value={value}>
      {children}
    </StudentPrivacyContext.Provider>
  );
};

export const useStudentPrivacy = () => useContext(StudentPrivacyContext);
